import { authClient, API } from "../index";
import { uploadSingleFile } from "../files";

// Get all blogs
export const getBlogs = () => {
  return authClient().get(`${API}/blog?getDisabled=true`);
};

// Get blog by id
export const getBlogById = (id) => {
  return authClient().get(`${API}/blog/${id}`);
};

// Delete blog
export const deleteBlog = (id) => {
  return authClient().delete(`${API}/blog/${id}`);
};

// Create blog
export const postBlog = async (blog, selectedImage) => {
  // Si hay imagen seleccionada, subirla primero como archivo al servidor
  if (selectedImage) {
    try {
      console.log("📤 Subiendo imagen del blog como archivo...");
      const response = await uploadSingleFile(selectedImage, "blog");
      const url = response.data?.fileURL || response.data?.url || response.data?.path;
      if (url) {
        console.log("✅ Imagen subida correctamente:", url);
        blog.imageUrl = url;
      } else {
        console.error("❌ No se recibió URL del servidor:", response.data);
        throw new Error("No URL returned from upload");
      }
    } catch (uploadError) {
      console.error("❌ Error subiendo imagen del blog:", uploadError);
      throw uploadError;
    }
  } else {
    console.log("ℹ️ No hay imagen seleccionada, usando imageUrl existente:", blog.imageUrl?.substring(0, 50) + "...");
  }
  console.log("📝 Guardando blog con imageUrl:", blog.imageUrl?.startsWith("data:") ? "base64" : blog.imageUrl);
  return authClient().post(`${API}/blog`, blog);
};

// Update blog
export const updateBlog = async (id, blog, selectedImage) => {
  // Si hay imagen seleccionada, subirla primero como archivo al servidor
  if (selectedImage) {
    try {
      console.log("📤 Subiendo imagen del blog como archivo...");
      const response = await uploadSingleFile(selectedImage, "blog");
      const url = response.data?.fileURL || response.data?.url || response.data?.path;
      if (url) {
        console.log("✅ Imagen subida correctamente:", url);
        blog.imageUrl = url;
      } else {
        console.error("❌ No se recibió URL del servidor:", response.data);
        throw new Error("No URL returned from upload");
      }
    } catch (uploadError) {
      console.error("❌ Error subiendo imagen del blog:", uploadError);
      throw uploadError;
    }
  } else {
    // Si no hay imagen seleccionada pero el blog tiene base64, mantenerlo (no convertir automáticamente)
    console.log("ℹ️ No hay imagen seleccionada, usando imageUrl existente:", blog.imageUrl?.substring(0, 50) + "...");
  }
  console.log("📝 Actualizando blog con imageUrl:", blog.imageUrl?.startsWith("data:") ? "base64" : blog.imageUrl);
  return authClient().put(`${API}/blog/${id}`, blog);
};

// Change status blog
export const changeStatusBlog = async (id, active) => {
  return authClient().put(`${API}/blog/change-status/${id}`, { active });
};
